export default "__VITE_ASSET__C7LOHW1Y__"